// 解决浏览器非活动页定时器执行频率下降导致考试倒计时不准问题 https://blog.csdn.net/shuxiaohua/article/details/122627979
import 'hacktimer'
console.log(111)
export default defineNuxtPlugin(nuxtApp => {})
